"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGroup = exports.Radio = exports.RADIO_SIZES = void 0;
var react_1 = __importStar(require("react"));
var hooks_1 = require("../../../mantine-hooks/src");
var theme_1 = require("../../../mantine-theme/src");
var InputWrapper_1 = require("../InputWrapper/InputWrapper");
var Radio_1 = require("./Radio/Radio");
Object.defineProperty(exports, "Radio", { enumerable: true, get: function () { return Radio_1.Radio; } });
var Radio_styles_1 = require("./Radio/Radio.styles");
var RadioGroup_styles_1 = __importDefault(require("./RadioGroup.styles"));
exports.RADIO_SIZES = Radio_styles_1.sizes;
function RadioGroup(_a) {
    var className = _a.className, themeOverride = _a.themeOverride, name = _a.name, children = _a.children, value = _a.value, defaultValue = _a.defaultValue, onChange = _a.onChange, _b = _a.variant, variant = _b === void 0 ? 'horizontal' : _b, _c = _a.spacing, spacing = _c === void 0 ? 'md' : _c, color = _a.color, size = _a.size, others = __rest(_a, ["className", "themeOverride", "name", "children", "value", "defaultValue", "onChange", "variant", "spacing", "color", "size"]);
    var _d = react_1.useState(value || defaultValue || ''), _value = _d[0], setValue = _d[1];
    var finalValue = typeof value === 'string' ? value : _value;
    var classes = RadioGroup_styles_1.default({ spacing: spacing, variant: variant, theme: theme_1.useMantineTheme(themeOverride) });
    var uuid = hooks_1.useId(name);
    var handleChange = function (v) {
        setValue(v);
        typeof onChange === 'function' && onChange(v);
    };
    var radios = react_1.Children.toArray(children)
        .filter(function (item) { return item.type === Radio_1.Radio; })
        .map(function (radio, index) {
        return react_1.cloneElement(radio, {
            key: index,
            checked: finalValue === radio.props.value,
            name: uuid,
            color: color,
            size: size,
            onChange: function (event) {
                return handleChange(event.currentTarget.value);
            },
        });
    });
    return (react_1.default.createElement(InputWrapper_1.InputWrapper, __assign({ labelElement: "div" }, others),
        react_1.default.createElement("div", { role: "radiogroup", className: classes.wrapper }, radios)));
}
exports.RadioGroup = RadioGroup;
RadioGroup.displayName = '@mantine/core/RadioGroup';
